import { useContext } from 'react';
import {ApplicationContext} from "../Provider/ApplicationProvider";

export default function Table2({ title, list }) {
    const {selectedOptions, setSelectedOptions}= useContext(ApplicationContext);

    const handleCheckboxChange = (event, itemId, itemTarget) => {
        if (event.target.checked) {
            setSelectedOptions([...selectedOptions, { id: itemId, target: itemTarget, value: "" }]);
        } else {
            const updatedItems = selectedOptions.filter((item) => item.id !== itemId);
            setSelectedOptions(updatedItems);
        }
    };

    const handleInputChange = (event, itemId) => {
        const inputValue = event.target.value.trim();

        if (inputValue !== "") {
            const existingItem = selectedOptions.find((item) => item.id === itemId);

            if (!existingItem) {
                setSelectedOptions([...selectedOptions, { id: itemId, value: inputValue }]);
            } else {
                const updatedItems = selectedOptions.map((item) => {
                    if (item.id === itemId) {
                        return { ...item, value: inputValue };
                    }
                    return item;
                });
                setSelectedOptions(updatedItems);
            }
        } else {
            const updatedItems = selectedOptions.filter((item) => item.id !== itemId);
            setSelectedOptions(updatedItems);
        }
    };

    return (
        <div>
            <small className="text-light fw-semibold">{title}</small>
            <div className="demo-inline-spacing mt-3">
                <div className="list-group">
                    {list.map((item, index) => (
                        <div className="list-group-item" key={index}>
                            <div className="row">
                                <label htmlFor={item.id} className="col-md-4 col-form-label">
                                    <input
                                        className="form-check-input me-1"
                                        type="checkbox"
                                        value={item.id}
                                        onChange={(event) =>
                                            handleCheckboxChange(event, item.id, item.title)
                                        }
                                        checked={selectedOptions.some((checkedItem) => checkedItem.id === item.id)}
                                    />
                                    {item.title}
                                </label>
                                <div className="col-md-4">
                                    <input
                                        className="form-control"
                                        type={item.dataType.toLowerCase()}
                                        id={item.id}
                                        onChange={(event) => handleInputChange(event, item.id)}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
